import { createContext, useContext } from 'react';

export interface StrategySelectorItem {
  name: string;
  fileName: string;
  description: string;
  strategyKey: string;
}

export interface StrategySelectorContextValue {
  strategies: StrategySelectorItem[];
  selectedKeys: Set<string>;
  onToggle: (strategyKey: string) => void;
  expanded: boolean;
  toggleExpanded: () => void;
}

export const StrategySelectorContext = createContext<StrategySelectorContextValue | null>(null);

export const useStrategySelectorContext = () => {
  const ctx = useContext(StrategySelectorContext);
  if (!ctx) throw new Error('StrategySelector compound components must be used within <StrategySelector>');
  return ctx;
};
